(function() {
  var helpers = require('./embed_helpers');

  // Define various variables
  var contentUrl = '//content.predictinteractive.com';
  var embedURL = contentUrl + '/embeds/placement.js'; // jshint ignore:line
  var domain = helpers.get_pred_hostname();
  var currentScript = helpers.get_current_script(embedURL);
  var top_window = helpers.get_pred_topwin();
  var ig_q = {
    dom: domain,
    rand: Math.random() * 1E20,
    url: top_window.location.protocol
      + '//' + top_window.location.hostname
      + (top_window.location.port
          ? ':' + top_window.location.port
          : '')
      + top_window.location.pathname,
    href: top_window.location.href
  };

  // Check the query parameters for no escaping
  if (typeof ig_q.no_escape !== 'undefined') {
    top_window = window;
  }

  // if currentScript exists, add to the query parameters
  if (currentScript) {
    helpers.get_query_parameters(currentScript, ig_q);
  }

  // if a configuration object is found, add to query params
  // this was added to fix direct wordpress integrations
  // that removed the script tag after load
  if (
    typeof window.PREDICT_EMBED_CONFIG !== 'undefined'
    && typeof window.PREDICT_EMBED_CONFIG === 'object'
  ) {
    ig_q = Object.assign(ig_q, window.PREDICT_EMBED_CONFIG);
  }

  // if div id is provided in query params, use,
  // else use current script location.
  // this was added to fix direct wordpress integrations
  // that removed the script tag after load
  var insertLocation = typeof ig_q.div_id !== 'undefined'
    ? document.getElementById(ig_q.div_id)
    : currentScript;

  if (!insertLocation) {
    throw new Error('insert location not found');
  }

  // Make the item for the queue and add it
  helpers.add_que_item(top_window, insertLocation, ig_q);

  // Create the script
  var newScript = document.createElement('script');
  newScript.src = contentUrl + '/l/n/igloo.php?' + Object.keys(ig_q).map(function(key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(ig_q[key]);
  }).join('&');

  // Append the script and delete current script source
  top_window.document.body.appendChild(newScript);
  if (currentScript) currentScript.src = '';
})();
